import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23667 30877"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278272032">
        <path
          d="M23667 16262c0-340-149-677-436-904-500-396-1225-313-1621 186l-9776 12324-9777-12324c-396-499-1121-582-1620-186-500 396-583 1120-187 1620l10680 13463c218 275 552 436 904 436 351 0 685-161 903-436l10680-13463c169-212 250-465 250-716z"
          className="fil0"
        />
        <path
          d="M23667 8708c0-340-149-676-436-904-500-396-1225-313-1621 187l-9776 12323L2057 7991c-396-499-1121-583-1620-187-500 396-583 1122-187 1620l10680 13463c218 276 552 436 904 436 351 0 685-160 903-436L23417 9424c169-212 250-465 250-716z"
          className="fil0"
        />
        <path
          d="M23667 1154c0-340-149-676-436-904-500-396-1225-313-1621 187l-9776 12323L2057 437C1661-62 936-146 437 250-63 646-146 1371 250 1870l10680 13463c218 276 552 436 904 436 351 0 685-161 903-436L23417 1870c169-212 250-464 250-716z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
